/**
 * O que faz: Mostra um recorte ilustrativo do funil e do atendimento na tela de login.
 * Onde usa: Coluna direita da rota /login, só em telas largas.
 * Conexões: CSS isolado em login-gens.css; não lê dados reais.
 * Tabelas: Nenhuma; os cartões são decorativos e não representam pacientes.
 * Data: 19/09/2026.
 */
import { Bot } from 'lucide-react';

export function PainelPreviewLogin() {
  return (
    <aside className="login-gens-preview" aria-hidden="true">
      <div className="login-gens-preview-stage">
        <article className="login-gens-cartao login-gens-cartao-fundo">
          <div className="login-gens-cartao-cabecalho">
            <span>Atendimento</span>
            <span className="login-gens-cartao-fechar">×</span>
          </div>
          <div className="login-gens-chat">
            <p>Quero agendar uma avaliação.</p>
            <p>
              <Bot size={14} aria-hidden="true" /> Vamos te ajudar.
            </p>
          </div>
        </article>

        <article className="login-gens-cartao login-gens-cartao-frente">
          <div className="login-gens-cartao-cabecalho">
            <span>Funil da clínica</span>
            <span className="login-gens-cartao-fechar">×</span>
          </div>
          <div className="login-gens-kanban">
            <div>
              <small>Novo contato</small>
              <span />
              <span />
            </div>
            <div>
              <small>Em conversa</small>
              <span className="login-gens-kanban-ativo">
                <i />
                Próximo passo
              </span>
              <span />
            </div>
            <div>
              <small>Agendamento</small>
              <span />
            </div>
          </div>
        </article>
      </div>

      <div className="login-gens-preview-copy">
        <h2>
          Atendimento, funil e <em>agenda</em> no mesmo lugar
        </h2>
        <p>Acompanhe cada conversa até o agendamento.</p>
        <div className="login-gens-bolinhas">
          <span />
          <span />
          <span />
        </div>
      </div>
    </aside>
  );
}
